<template>
  <section class="notification-bar" v-if="notification">
    <p>{{notification}}</p>
    <img src="@/assets/close.svg" @click="close()">
  </section>
</template>
<script>
export default {
  name: 'notificationBar',
  props: ['notification'],
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.notification-bar {
  display: flex;
  padding: 10px 40px;
  background: #f6b92f;
  color: white;
  font-weight: bold;
  align-items: center;
  img {
    cursor: pointer;
    margin-left: auto;
  }
}
</style>